

import Vue from "vue";
import Navigation_bar from "./components/Navigation_bar.vue";
import Pre_footer from "./components/Pre_footer.vue";
import Footer from "./components/Footer.vue";
import "@/assets/css/main.css"
const Whatsapp = () => import("@/components/Home_Sections/Whatsapp.vue")

export default Vue.extend({
  name: "App",
  components: {
    Navigation_bar,
    Footer,
    Pre_footer,
    Whatsapp
  },
  data: () => ({
    //


  }),
});
